import "bootstrap/dist/css/bootstrap.min.css";
import styled from "styled-components";
import { BsArrowRepeat } from "react-icons/bs";
import { MdFileDownload } from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";

const InvoicesSuper = () => {
  return (
    <Wrapper>
      <div className="container py-5">
        <div className="card border-0 shadow-sm p-4">
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
            <div>
              <h4 className="text-dark mb-1 d-flex align-items-center">
                All Invoices
              </h4>
              <p className="text-muted mb-0">
                View and manage all generated invoices for bookings
              </p>
            </div>
            <div className="d-flex gap-3 mt-2 mt-md-0">
              <button className="btn btn-outline-primary d-flex align-items-center">
                <MdFileDownload className="me-2" size={20} />
                Generate Invoice
              </button>
              <button className="btn btn-primary d-flex align-items-center">
                <MdFileDownload className="me-2" size={20} />
                Export Invoice
              </button>
            </div>
          </div>
          <div className="d-flex align-items-center flex-wrap gap-2 mb-3 filter-box">
            <input
              type="text"
              className="form-control"
              placeholder="Search ID, Customer, Service"
            />
            <select className="form-select">
              <option>All Time</option>
              <option>Today</option>
              <option>Last Week </option>
              <option>Last Month</option>
              <option>Custom Date/Range</option>
            </select>
            <select className="form-select">
              <option>All Statuses</option>
              <option>Online Sales</option>
              <option>Counter Sales</option>
            </select>
            <select className="form-select">
              <option>All Types</option>
              <option>Online</option>
              <option>Counter</option>
            </select>
            <button className="btn btn-outline-secondary d-flex align-items-center gap-1">
              <BsArrowRepeat size={16} />
              Clear Filters
            </button>
          </div>

          <TableWrapper>
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th>Invoice #</th>
                  <th>Issue Date</th>
                  <th>Due Date</th>
                  <th>Billed To</th>
                  <th>Type</th>
                  <th>Total Amount</th>
                  <th>Status</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>INV-2024-07-001</strong></td>
                  <td>Jul 15, 2024</td>
                  <td>Jul 30, 2024</td>
                  <td>Alice Wonderland</td>
                  <td><span className="badge bg-primary-subtle text-primary">Booking</span></td>
                  <td><strong>45.00 USD</strong></td>
                  <td><span className="badge bg-success-subtle text-success">Paid</span></td>
                  <td className="text-center"><BsThreeDotsVertical /></td>
                </tr>
                <tr>
                  <td><strong>INV-2024-07-002</strong></td>
                  <td>Mar 22, 2024</td>
                  <td>Apr 5, 2024</td>
                  <td>ThrillSeeker Adventures</td>
                  <td><span className="badge bg-success-subtle text-success">Registration Fee</span></td>
                  <td><strong>50.00 USD</strong></td>
                  <td><span className="badge bg-success-subtle text-success">Paid</span></td>
                  <td className="text-center"><BsThreeDotsVertical /></td>
                </tr>
                <tr>
                  <td><strong>INV-2024-07-003</strong></td>
                  <td>Jul 1, 2024</td>
                  <td>Jul 15, 2024</td>
                  <td>Aqua Fun Waterpark</td>
                  <td><span className="badge bg-purple">Subscription</span></td>
                  <td><strong>29.99 USD</strong></td>
                  <td><span className="badge bg-success-subtle text-success">Paid</span></td>
                  <td className="text-center"><BsThreeDotsVertical /></td>
                </tr>
                <tr>
                  <td><strong>INV-2024-08-001</strong></td>
                  <td>Jul 23, 2024</td>
                  <td>Aug 7, 2024</td>
                  <td>Diana Prince</td>
                  <td><span className="badge bg-primary-subtle text-primary">Booking</span></td>
                  <td><strong>55.00 USD</strong></td>
                  <td><span className="badge bg-warning-subtle text-warning">Unpaid</span></td>
                  <td className="text-center"><BsThreeDotsVertical /></td>
                </tr>
              </tbody>
            </table>
          </TableWrapper>
        </div>
      </div>
    </Wrapper>
  );
};

export default InvoicesSuper;

const Wrapper = styled.div`
  .filter-box input,
  .filter-box select {
    width: 169px !important;
  }
`;

const TableWrapper = styled.div`
  .badge {
    font-size: 0.75rem;
    border-radius: 12px;
    padding: 4px 10px;
    font-weight: 500;
  }

  .badge-paid {
    background-color: rgba(25, 135, 84, 0.15);
    color: #198754;
  }

  .badge-pending {
    background-color: rgba(255, 193, 7, 0.2);
    color: #ffc107;
  }

  .badge-processing {
    background-color: rgba(13, 202, 240, 0.2);
    color: #0dcaf0;
  }

  .highlighted-row {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .table th,
  .table td {
    vertical-align: middle;
  }

  .text-center {
    text-align: center;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
  }

  th,
  td {
    padding: 10px 12px;
    border: 1px solid #dee2e6;
    text-align: center;
    vertical-align: middle;
  }

  th {
    background-color: #f8f9fa;
    font-weight: 600;
  }

  .badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
  }

  .badge.tour {
    background-color: rgba(255, 0, 150, 0.1);
    color: #d63384;
  }

  .badge.business {
    background-color: rgba(0, 123, 255, 0.1);
    color: #0d6efd;
  }

  .badge.org {
    background-color: rgba(0, 200, 150, 0.1);
    color: #20c997;
  }

  .stars {
    white-space: nowrap;
    font-size: 16px;
    color: #f4c150;
  }

  .bold {
    font-weight: bold;
    color: #007bff;
  }
     .badge {
    padding: 6px 10px;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 500;
  }

  .bg-purple {
    background-color: rgba(155, 89, 182, 0.15);
    color: #9b59b6;
  }

  .table th,
  .table td {
    vertical-align: middle;
  }

  .text-center {
    text-align: center;
  }

`;
